
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/buildyourdreamsetup/[locale]/landing",
      function () {
        return require("private-next-pages/buildyourdreamsetup/[locale]/landing.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/buildyourdreamsetup/[locale]/landing"])
      });
    }
  